let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2LBoO")).then(() => parcelRequire('aIXeC'));